import { createTheme } from '@mui/material';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';
import { defaultProps as MuiButtonDefaultProps } from './overrides/MuiButton';

const defaultPropsByComponent = {
  MuiButton: MuiButtonDefaultProps,
  MuiTextField: { variant: 'standard' },
  MuiSelect: { variant: 'standard' },
  MuiFormControl: { variant: 'standard' },
  MuiCheckbox: { color: 'secondary' },
  MuiRadio: { color: 'secondary' },
  MuiSwitch: { color: 'secondary' },
  MuiButtonGroup: { color: 'inherit' },
  MuiLink: { underline: 'hover' },
  MuiTabs: { indicatorColor: 'secondary', textColor: 'inherit' },
};

// Converter overrides do formato MUI 4 para MUI 7
const convertToMui7Components = (oldOverrides) => {
  const components = {};
  for (const [componentName, styles] of Object.entries(oldOverrides)) {
    components[componentName] = {
      styleOverrides: styles,
    };
  }
  for (const [componentName, defaultProps] of Object.entries(defaultPropsByComponent)) {
    components[componentName] = {
      ...components[componentName],
      defaultProps,
    };
  }
  return components;
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette,
  typography,
  components: convertToMui7Components(overrides),
});

export default theme;
